<template>
  <div>
    <v-card>
      <v-toolbar card prominent>
        <v-toolbar-title class="body-2 grey--text">{{
          $t("users.title")
        }}</v-toolbar-title>
      </v-toolbar>
    </v-card>
    <template>
      <v-card v-if="list">
        <v-card-title>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            :label="$t('rms.field.search')"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table :headers="table_headers" :items="list" :search="search">
          <template slot="headerCell" slot-scope="props">
            <v-tooltip top v-if="props.header.tooltip">
              <template v-slot:activator="{ on }">
                <span v-on="on">{{ props.header.text }}</span>
              </template>
              <span>{{ props.header.tooltip }}</span>
            </v-tooltip>
            <span v-else>{{ props.header.text }}</span>
          </template>

          <template v-slot:items="props">
            <td class="text-xs-left">{{ props.index + 1 }}</td>
            <td class="text-xs-left">
              {{
                props.item.name ? props.item.name : props.item.temp_user_name
              }}
            </td>
            <td class="text-xs-left">{{ props.item.email }}</td>
            <!-- <td class="text-xs-left" width="30%">
              <v-chip
                outline
                small
                color="success"
                v-for="company in props.item.companies"
                :key="company.id"
              >{{company.title}}</v-chip>
            </td> -->
            <td class="text-xs-left">
              {{ DEFINES.USER_ROLE_STR[props.item.role] }}
            </td>
            <td class="text-xs-left">
              {{ moment.utc(props.item.created_at).format("MMM Do, YYYY") }}
            </td>
            <td class="text-xs-left">
              <ConfirmationDialog
                :desc="'screener.registrant.remove.confirmation.description'"
                :action="getDialogAction(props.item.id, 'rms_delete', 'error')"
                :headline="'screener.registrant.remove.confirmation.heading'"
                :button_type="'icon'"
              ></ConfirmationDialog>
              <!-- <v-btn
                outline
                color="primary"
                :disabled="!canBeImpersonated(props.item.id)"
                @click="impersonate(props.item.id)"
              >{{ $t('rms.admin.user.impersonate') }}</v-btn> -->
            </td>
          </template>
          <template v-slot:no-results>
            <v-alert :value="true" color="error" icon="warning">
              {{
                $t("rms.alert.search_not_found", {
                  search: search,
                })
              }}
            </v-alert>
          </template>
        </v-data-table>
      </v-card>
      <v-card v-else>
        <v-container fluid grid-list-lg>
          <v-alert :value="true" type="error">Didn't Found Any User</v-alert>
        </v-container>
      </v-card>
    </template>
  </div>
</template>
<script>
import ConfirmationDialog from "@/components/ConfirmationDialog";
import { mapState, mapGetters } from "vuex";
import i18n from "@/i18n";
import moment from "moment";
import { mapFields } from "vuex-map-fields";
export default {
  name: "AdminUserList",
  components: { ConfirmationDialog },
  data() {
    return {
      moment,
      search: "",
      table_headers: [
        { text: i18n.t("rms.table.header.sn"), align: "left", sortable: false },
        {
          text: i18n.t("rms.table.header.name"),
          align: "left",
          sortable: false,
          value: "name",
        },
        {
          text: i18n.t("rms.table.header.email"),
          align: "left",
          sortable: false,
        },
        // {
        //   text: i18n.t("rms.table.header.companies"),
        //   align: "left",
        //   sortable: false
        // },
        {
          text: i18n.t("rms.table.header.role"),
          align: "left",
          sortable: false,
        },
        { text: i18n.t("rms.table.header.created_on"), sortable: true },
        // {
        //   text: i18n.t("rms.table.header.impersonate"),
        //   align: "left",
        //   sortable: false
        // }
        {
          text: "Action",
          align: "left",
          value: "delete",
          sortable: false,
        },
      ],
    };
  },

  mounted() {
    this.getUsers();
  },

  computed: {
    ...mapGetters({
      logged_in_user: "user/getUser",
    }),
    ...mapFields("adminUser", ["list"]),
  },

  methods: {
    async getUsers(type) {
      await this.$store.dispatch("adminUser/list");
    },

    getDialogAction(user_id = null, btn_icon, btn_color, btn_lable) {
      return {
        button_icon: btn_icon,
        button_color: btn_color,
        button_label: btn_lable,
        no_outline: true,
        method: this.deleteUserDetails,
        payload: user_id,
      };
    },

    async deleteUserDetails(consumer_id) {
      await this.$store
        .dispatch("adminUser/deleteUserDetails", {
          id: consumer_id,
        })
        .then((response) => {
          this.$store.dispatch("app/showMessage", {
            message: i18n.t("screener.consumer.deleted_details_successfully"),
            color: "success",
          });

          this.getUsers();
        })
        .catch((error) => {
          this.$store.dispatch("app/showMessage", {
            message: error.message,
            color: "error",
          });
        });
    },

    // canBeImpersonated(user_id) {
    //   return !(this.logged_in_user.id == user_id);
    // },

    // impersonate(user_id) {
    //   this.$router.push({
    //     name: "ImpersonationConfirmation",
    //     params: {
    //       user_id: user_id
    //     }
    //   });
    // }
  },
};
</script>
